import { useEffect } from 'react';
import {
  GOOGLE_MERCHANT_ID,
  GOOGLE_GCR_LANGUAGE,
  GOOGLE_GCR_OPT_IN_STYLE,
  isGoogleCustomerReviewsEnabled,
} from '../utils/googleCustomerReviews';

const PLATFORM_SCRIPT_ID = 'google-gcr-platform';

/**
 * Google Customer Reviews survey opt-in on the order confirmation page.
 * Requires order id, customer email, country, and estimated delivery date.
 */
const GoogleCustomerReviewsOptIn = ({ order }) => {
  const email = String(order?.email || '').trim();
  const orderId = String(order?.orderId || '').trim();
  const deliveryCountry = String(order?.deliveryCountry || 'KE').trim();
  const estimatedDeliveryDate = String(order?.estimatedDeliveryDate || '').trim();

  useEffect(() => {
    if (!isGoogleCustomerReviewsEnabled()) return undefined;
    if (!email || !orderId || !estimatedDeliveryDate) return undefined;

    const renderOptIn = () => {
      if (!window.gapi?.load) return;
      window.gapi.load('surveyoptin', () => {
        window.gapi.surveyoptin.render({
          merchant_id: GOOGLE_MERCHANT_ID,
          order_id: orderId,
          email,
          delivery_country: deliveryCountry,
          estimated_delivery_date: estimatedDeliveryDate,
          opt_in_style: GOOGLE_GCR_OPT_IN_STYLE,
        });
      });
    };

    window.___gcfg = { lang: GOOGLE_GCR_LANGUAGE };
    window.renderOptIn = renderOptIn;

    if (window.gapi?.load) {
      renderOptIn();
      return undefined;
    }

    let script = document.getElementById(PLATFORM_SCRIPT_ID);
    if (!script) {
      script = document.createElement('script');
      script.id = PLATFORM_SCRIPT_ID;
      script.src = 'https://apis.google.com/js/platform.js?onload=renderOptIn';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    return () => {
      if (window.renderOptIn === renderOptIn) {
        delete window.renderOptIn;
      }
    };
  }, [email, orderId, deliveryCountry, estimatedDeliveryDate]);

  return null;
};

export default GoogleCustomerReviewsOptIn;
